import { configureStore } from '@reduxjs/toolkit';
import initialSliceReducer from '../features/initialSlice/initialSlice';
import mainSliceReducer from '../features/mainSlice/mainSlice';

export type { AppThunk, RootState } from './rootState';

export const store = configureStore({
  reducer: {
    initialSlice: initialSliceReducer,
    mainSlice: mainSliceReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
